export interface ILeadsGroup {
    name: string;
    [key: string]: unknown;
  }
  
  class UTILSService {
    public readonly EMAIL_REGEX: RegExp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
  
    public isDefined(value: unknown): boolean {
      if (!value) return false;
      if (value == null || value === undefined) return false;
      return true;
    }
  
 
    public checkLeadsName(checkValue: string, leadsGroups: ILeadsGroup[]): boolean {
      // console.log(" => leadsGroup: ", leadsGroups);
      for (let i = 0; i < leadsGroups.length; i++) {
        if (leadsGroups[i]?.name === checkValue) {
          return false;
        }
      }
      return true;
    }
  }
  
  export default new UTILSService();
  